import {profissionais} from '../../dados/profissionais'

import Alfredo from '../../assets/imagens/Alfredo.png'
import Code1 from '../../assets/imagens/coding1.png'
import Code2 from '../../assets/imagens/coding2.png'

import Header from '../../components/Header'
import CardProfissionais from '../../components/ui/CardProfissionais';
import Introducao from '../../components/Introducao';
import Typing from '../../components/ui/Typing'

import {motion, useScroll, useSpring, useTransform } from 'motion/react';
import {useRef} from 'react'


import './SobreNos.css'
export default function SobreNos(){
    
    const scrollRef = useRef(null)
    const {scrollYProgress} = useScroll({
        target: scrollRef,
        offset:["start start","end start"]
    })

    const progress = useSpring(scrollYProgress,{
        stiffness: 300,
        damping: 50,
        restDelta: 0.001
    })


    const xEsquerda = useTransform(
        progress,
        [0, 0.25],
        ["0vw", "32vw"]
    )

    const xDireita = useTransform(
        progress,
        [0,0.25],
        ["0vw", "-32vw"]
    )

    const opacity = useTransform(
        progress,
        [0, 0.25, 0.50, 1],
        [0, 1, 0.25, 0]
    )

    const opacityTitulo = useTransform(
        progress,
        [0, 0.25],
        [1, 0]
    )

    const opacityTexto = useTransform(
        progress,
        [0, 0.30],
        [0, 1 ]
    )

    return (
        <>
        <Header />  

        <section ref={scrollRef} className="containerProfissionais">
            
            <div className="areaTexto">
                <motion.div className='containerTexto' style={{opacity:opacityTitulo}}>
                    <Typing
                        text="Conheça nossos heróis da TI"
                        speed={130}
                        />
                </motion.div>
            </div>
            <div className="elementoAnimado">
                <motion.img className="elementoAnimadoImagem" src={Code1} style={{x: xEsquerda, opacity:opacity}}/>
                <motion.img className="elementoAnimadoImagem2" src={Code2} style={{x: xDireita, opacity: opacity}}/>
            </div>
            
        </section>
        <div className="areaProfissionais">
                <h2 className="titulo">Passe o mouse por cima para descobrir o que cada um faz</h2>
                <span className="telaPequena">(utilize um computador para melhor experiência)</span>
                <div className="flex containerSobreNos">
                    
                    {profissionais.map((p)=>(
                        <CardProfissionais p={p} />
                    ))}
                </div>
            </div>

        {/* <div className="containerDefault">
            
            <Introducao>
                    <h1>Conheça nossos heróis</h1>

                    <p>
                        Cada problema resolvido, cada sistema funcionando e cada usuário ajudado só é possível porque existem profissionais trabalhando nos bastidores todos os dias.
                    </p>
                    <h2 className="destaque">Eles têm habilidades diferentes, mas todos têm algo em comum: fazem a TI acontecer.</h2>
            </Introducao>

            
        </div> */}
        </>
    )
}